import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: "23696426-9b52-4fcc-a841-2efd8859274b",
});
